import classNames from 'classnames';
import { FC, PropsWithChildren, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { mediaQueryDown } from 'utils/mediaQueries';

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--spacer-4);

  #product-summary {
    grid-column: 1;
    grid-row: 1 / 4;
  }
  #trade-information,
  #sales-margin-information,
  #booking-information {
    grid-column: 2;
  }

  ${mediaQueryDown('xxl')(css`
    grid-template-columns: repeat(1, 1fr);

    > * {
      grid-column: 1 !important;
      grid-row: auto !important;
    }
  `)}
`;

export const SecondaryFormTemplate: FC<
  PropsWithChildren<{
    toolbar?: ReactNode;
    sidePanel: ReactNode;
    bigSidePanel: boolean;
  }>
> = ({ toolbar, sidePanel, children, bigSidePanel }) => {
  return (
    <div className="d-flex flex-column flex-lg-row bg-lvl3 h-100 overflow-hidden" data-e2e="secondary-market-container">
      <div
        className={classNames('d-flex flex-column overflow-auto p-0 col-lg-7', {
          'col-xxl-8': bigSidePanel,
          'col-xxl-9': !bigSidePanel,
        })}
      >
        {toolbar}
        <FormGrid className="w-100 p-3">{children}</FormGrid>
      </div>
      <div
        className={classNames('h-100 p-lg-0 col-lg-5', {
          'col-xxl-4': bigSidePanel,
          'col-xxl-3': !bigSidePanel,
        })}
      >
        {sidePanel}
      </div>
    </div>
  );
};
